import React from "react"

// Context
import {useUiSkin} from "../../../ui-skin/context/UiSkinContext"

// Components
import SignInPage from "../SignInPage"
import ModernSignInPage from "../modern/ModernSignInPage"

/**
 * Skin seam for the sign-in route.
 *
 * Mounted by <App/> in place of the Classic <SignInPage/>; the Classic page is
 * left byte-for-byte untouched behind this switch, so flipping back to Classic
 * renders exactly what shipped before the Modern skin existed.
 *
 * @param props
 */
export default function SignInPageSwitch(props: {}) {
    const {isModern} = useUiSkin();

    if (isModern) {
        return <ModernSignInPage {...props}/>
    }

    return <SignInPage {...props}/>
}
